import { FREE_PAGES } from "./pagesFree";
import { LOCKED_PAGES } from "./pagesLocked";

export const CATEGORIES = [
  {
    id: "free",
    name: "Starter Scribbles",
    blurb: "Warm up your crayons on these classics",
    tag: "For Everyone",
    unlockAt: 0,
    accent: "#FF7A00",
  },
  {
    id: "heroes",
    name: "Superhero Spooks",
    blurb: "Capes meet jack-o'-lanterns. For boys who save the night",
    tag: "For Boys",
    unlockAt: 3,
    accent: "#8A4FFF",
  },
  {
    id: "kitty",
    name: "Kitty & Friends",
    blurb: "Purrfectly spooky kitties. For girls who love cute",
    tag: "For Girls",
    unlockAt: 6,
    accent: "#FF5CA8",
  },
  {
    id: "anime",
    name: "Anime Ghost Hunters",
    blurb: "Chibi heroes chasing friendly ghosts. For boys",
    tag: "For Boys",
    unlockAt: 9,
    accent: "#39FF14",
  },
  {
    id: "glam",
    name: "Glam Ghouls",
    blurb: "Fierce and fabulous ghoul fashion. For girls",
    tag: "For Girls",
    unlockAt: 12,
    accent: "#FFA24D",
  },
];

export const PAGES = [
  ...FREE_PAGES,
  ...LOCKED_PAGES,
  {
    id: "happy-halloween-friends",
    title: "Happy Halloween Friends",
    category: "free",
    difficulty: 2,
    blurb: "A friendly ghost, a magic kitty and pumpkins galore",
    imagePage: true,
    image: "/pages/happy-halloween-friends.jpg",
  },
  {
    id: "dino-witch",
    title: "Dino Witch",
    category: "free",
    difficulty: 3,
    blurb: "A dino-rrific witch collecting candy in the pumpkin patch",
    imagePage: true,
    image: "/pages/dino-witch.jpg",
  },
];

export function getPage(id) {
  return PAGES.find((p) => p.id === id) || null;
}

export function getCategory(id) {
  return CATEGORIES.find((c) => c.id === id) || null;
}

export const TOTAL_PAGES = PAGES.length;
